import type { ReactNode } from 'react';

interface EmptyStateProps {
  illustration?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ illustration, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={
        'flex flex-col items-center justify-center gap-3 text-center py-12 px-6 ' +
        (className ?? '')
      }
    >
      {illustration && (
        <div className="text-ink-tertiary mb-2" aria-hidden>
          {illustration}
        </div>
      )}
      <h2 className="font-serif text-xl font-semibold text-ink-primary">{title}</h2>
      {body && <p className="text-sm text-ink-secondary max-w-md">{body}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
